var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0962 36C30.3269 36 32.2115 35.0125 33.75 33.0376C35.25 31.0626 36 28.229 36 24.5367C36 19.2129 34.8462 14.4472 32.5385 10.2397C30.1923 6.0322 27.0577 2.61896 23.1346 0L20.3077 4.70125C23.2308 6.89088 25.4423 9.50984 26.9423 12.5581C28.4038 15.5635 29.1346 18.9553 29.1346 22.7335C28.9423 22.6476 28.5962 22.6047 28.0962 22.6047C26.5577 22.6047 25.1731 23.1628 23.9423 24.2791C22.7115 25.3524 22.0962 26.9624 22.0962 29.1091C22.0962 31.2558 22.6731 32.9517 23.8269 34.1968C24.9423 35.3989 26.3654 36 28.0962 36ZM7.78846 36C10.0192 36 11.9038 35.0125 13.4423 33.0376C14.9423 31.0626 15.6923 28.229 15.6923 24.5367C15.6923 19.2129 14.5385 14.4472 12.2308 10.2397C9.88461 6.0322 6.75 2.61896 2.82692 0L0 4.70125C2.92308 6.89088 5.13461 9.50984 6.63461 12.5581C8.09615 15.5635 8.82692 18.9553 8.82692 22.7335C8.63461 22.6476 8.28846 22.6047 7.78846 22.6047C6.25 22.6047 4.86538 23.1628 3.63461 24.2791C2.40385 25.3524 1.78846 26.9624 1.78846 29.1091C1.78846 31.2558 2.36538 32.9517 3.51923 34.1968C4.63461 35.3989 6.05769 36 7.78846 36Z",
    fill: "#063085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.2ea4f7f55289f630c7cc467dab5c6f8d.svg";
export { ForwardRef as ReactComponent };